import { LatLng, LatLngBounds, LatLngTuple } from "leaflet";

export const getLatLngForXY = (bounds: LatLngBounds, x: number | null, y: number | null): LatLngTuple | null => {
    if (x === null || y === null) return null;

    const mapWidth = bounds.getEast() - bounds.getWest();
    const mapHeight = bounds.getNorth() - bounds.getSouth();

    const lng = mapWidth * x;
    const lat = mapHeight * y;

    return [lat, lng];
};

export const getXYForLatLng = (bounds: LatLngBounds, latLng: LatLng): { x: number; y: number } => {
    const mapWidth = bounds.getEast() - bounds.getWest();
    const mapHeight = bounds.getNorth() - bounds.getSouth();

    const x = (latLng.lng - bounds.getWest()) / mapWidth;
    const y = 1 + (latLng.lat - bounds.getNorth()) / mapHeight;

    return { x, y };
};
